
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { AuthForm } from "@/components/auth/AuthForm";
import { useState, useEffect } from "react";
import { User, LogOut, Shield, Users, Settings, FileText } from "lucide-react";
import { hasRole } from "@/utils/auth";
import { Link } from "react-router-dom";

export function UserMenu() {
  const { user, isAuthenticated, logout } = useAuth();
  const [authOpen, setAuthOpen] = useState(false);
  const [authMode, setAuthMode] = useState<"signin" | "signup">("signin");
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    if (user && user.roles) {
      setIsAdmin(hasRole(user, 'admin'));
      console.log("User roles:", user.roles, "Is admin:", hasRole(user, 'admin'));
    } else {
      setIsAdmin(false);
    }
  }, [user]);

  const handleSignIn = () => {
    setAuthMode("signin");
    setAuthOpen(true);
  };

  const handleSignUp = () => {
    setAuthMode("signup");
    setAuthOpen(true);
  };

  const handleLogout = async () => {
    await logout();
  };

  return (
    <>
      {isAuthenticated ? (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="relative h-10 w-10 p-0">
              <Avatar>
                <AvatarFallback className="bg-primary/10">
                  <User className="h-4 w-4 text-primary" />
                </AvatarFallback>
              </Avatar>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent className="w-56" align="end">
            <DropdownMenuLabel>My Account</DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem disabled>
              {user?.email}
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link to="/profile" className="flex items-center w-full cursor-pointer">
                <Settings className="mr-2 h-4 w-4" />
                <span>Profile Settings</span>
              </Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link to="/results" className="flex items-center w-full cursor-pointer">
                <FileText className="mr-2 h-4 w-4" />
                <span>My Results</span>
              </Link>
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            {isAdmin && (
              <>
                <DropdownMenuItem asChild>
                  <Link to="/admin" className="flex items-center w-full cursor-pointer">
                    <Shield className="mr-2 h-4 w-4" />
                    <span>Admin Dashboard</span>
                  </Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <Link to="/users" className="flex items-center w-full cursor-pointer">
                    <Users className="mr-2 h-4 w-4" />
                    <span>User Management</span>
                  </Link>
                </DropdownMenuItem>
              </>
            )}
            <DropdownMenuItem onClick={handleLogout}>
              <LogOut className="mr-2 h-4 w-4" />
              <span>Log out</span>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      ) : (
        <div className="flex items-center space-x-2">
          <Button variant="ghost" onClick={handleSignIn}>
            Sign In
          </Button>
          <Button onClick={handleSignUp}>
            Sign Up
          </Button>
        </div>
      )}

      <AuthForm
        open={authOpen}
        onOpenChange={setAuthOpen}
        onSuccess={() => setAuthOpen(false)}
        defaultMode={authMode}
      />
    </>
  );
}
